import React from 'react';
import { useLanguage } from '../contexts/LanguageContext';
import { motion } from 'framer-motion';
import { Star } from 'lucide-react';
export function ClientRatings() {
  const {
    t
  } = useLanguage();
  return <section className="py-24 bg-ocean-dark text-white" data-id="element-65">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center" data-id="element-66">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} data-id="element-67">
          <div className="flex items-center justify-center gap-1 mb-4 text-turquoise" data-id="element-68">
            {Array.from({
            length: 5
          }).map((_, i) => <Star key={i} size={22} fill="currentColor" data-id="element-69" />)}
          </div>
          <h2 className="text-4xl font-heading font-bold mb-4" data-id="element-70">
            {t.clientRatings.title}
          </h2>
          <p className="text-white/70 max-w-2xl mx-auto mb-10" data-id="element-71">
            {t.clientRatings.subtitle}
          </p>
        </motion.div>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-4" data-id="element-72">
          <motion.a href="http://airbnb.com/x/rainforesttourlikealocal" target="_blank" rel="noreferrer" initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.1
        }} whileHover={{
          scale: 1.05
        }} className="flex items-center gap-2 bg-rainforest hover:bg-rainforest-light text-white px-8 py-4 rounded-full font-semibold text-lg transition-colors shadow-[0_0_20px_rgba(26,67,49,0.5)] w-full sm:w-auto justify-center" data-id="element-73">
            <Star size={20} data-id="element-74" />
            {t.clientRatings.sweetSalty}
          </motion.a>
          <motion.a href="https://share.google/tMvaYTA2Yu5t2ZAyC" target="_blank" rel="noreferrer" initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.2
        }} whileHover={{
          scale: 1.05
        }} className="flex items-center gap-2 bg-turquoise hover:bg-turquoise-light text-white px-8 py-4 rounded-full font-semibold text-lg transition-colors shadow-[0_0_20px_rgba(0,180,216,0.4)] w-full sm:w-auto justify-center" data-id="element-75">
            <Star size={20} data-id="element-76" />
            {t.clientRatings.bluOcean}
          </motion.a>
        </div>
      </div>
    </section>;
}